import { z } from "zod";
import { SortableColumnKey } from "./-hooks/useColumns";

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  appIdIn: z.array(z.string()).optional(),
  // no-userは workerで検索しても良いかも

  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  sortColumn: z.enum(SortableColumnKey).optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
});

export type SearchParams = z.infer<typeof SearchSchema>;
